import poolsMutations from "./mutations.js";
import poolsActions from "./actions.js";
import poolsGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            pools:{},
            pool_devices:{}
        };
    },
    mutations: poolsMutations,
    actions: poolsActions,
    getters: poolsGetters,
};